export default __webpack_public_path__ + "static/media/english-design-thinking.4e660baf.jpg";